$slanted-mask-width: 1945px;
$slanted-mask-height: 136px;
$aspect-ratio-desktop: 2.9;

:host {
  width: 100%;
  height: 0;
  box-sizing: border-box;
}

:host(.visited) {
  height: 100%;
}

.container {
  display: grid;
  grid-template-columns: 1fr;

  @include media-min('lg') {
    grid-template-columns: 61.1% 38.9%;
    aspect-ratio: $aspect-ratio-desktop;

    &.image-only {
      grid-template-columns: 1fr;
    }
  }

  &:not(.image-only) {
    @include media-max('lg') {
      background-color: $color-dark-blue-02;
    }
  }
}

.image-wrapper {
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  background-color: $color-grey-03;
  aspect-ratio: 16 / 9;

  @include media-max('lg') {
    clip-path: polygon(0 0, $slanted-mask-width 0, $slanted-mask-width calc(100% - $slanted-mask-height), 0 100%);
  }

  @include media-min('lg') {
    .container.image-only & {
      aspect-ratio: $aspect-ratio-desktop;
    }
  }
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 48px 32px 72px;
  box-sizing: border-box;
  overflow: hidden;
  color: $color-white;
  background-color: $color-dark-blue-02;

  @include media-min('lg') {
    padding: 24px 60px 72px 24px;
  }

  @include media-min('xl') {
    padding: 48px 80px 72px 32px;
  }

  .copy-wrapper {
    overflow: hidden;
    --text-fade-mask: linear-gradient(to top, rgba(0, 0, 0, 0) 24px, rgba(0, 0, 0, 1) 48px);
    -webkit-mask: var(--text-fade-mask);
    mask: var(--text-fade-mask);

    slot[name='copy'] {
      display: inline-block;
      margin-bottom: 48px;
    }
  }
}
